import { Button, Modal } from "antd";
import { useState } from "react";
import { AddOnDtoTypeEnum, DsaScreenDto } from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";
import "./ConfirmationModal.scss";
import AccountsApi from "../../api/AccountsApi";
import { useRecoilValue } from "recoil";
import { memberState } from "../../state/atoms";

export interface RemoveScreenModalProps {
  isVisible: boolean;
  onClose: (fetch: boolean) => void;
  active: DsaScreenDto;
}

export function RemoveScreenModal({
  isVisible,
  onClose,
  active
}: RemoveScreenModalProps) {
  const [loading, setLoading] = useState(false);
  const member = useRecoilValue(memberState);

  async function unpair() {
    if (!active.serial) return;
    setLoading(true);
    await DSAApi.deleteScreen(active.serial);

    if (member.enterpriseDisplayAccount) {
      await AccountsApi.removeSubscriptionAddon(member.id, AddOnDtoTypeEnum.Dsa);
    }
    setLoading(false);
    onClose(true);
  }

  return (
    <Modal
      className={"confirmation-modal clean"}
      open={isVisible}
      onCancel={() => onClose(false)}
    >
      <header>
        <h2>Are you sure you want to remove {active?.name!}?</h2>
      </header>

      <p>This screen will be removed and all its data will be lost.</p>

      <footer>
        <Button size={"large"} onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={() => unpair()}
          loading={loading}
        >
          Delete
        </Button>
      </footer>
    </Modal>
  );
}
